(function () {
  'use strict';

  angular
      .module('tfc.retailer.CollapsibleMenu')
      .directive('tfcCollapsibleMenu', tfcCollapsibleMenu);

  // @ngInject
  function tfcCollapsibleMenu() {
    return {
      restrict: 'A',
      replace: true,
      scope:true,

      link: function($scope,attr) {
        var expanded = null;
        var selected = null;
        var vm = $scope.vm;
        vm.isExpanded = function (item) {
          return expanded === item;
        };

        vm.toggleExpanded = function (item) {
          if (vm.isExpanded(item)) {
              expanded = null;
          } else {
              expanded = item;
          }
        };
        vm.onSelect = function(item) {
          vm.toggleExpanded(item);
          selected = item;
          if(!(item.children && item.children.length > 0)) {
            vm.onClick(item);
          }
        };
        vm.onMainSelect = function(item) {
          vm.onSelect(item);
          if (item.children && item.children.length > 0) {
            var firstAccessibleChild = _.find(item.children, function (child) {
              return vm.canAccess(child);
            });
            if (firstAccessibleChild) {
              vm.onClick(firstAccessibleChild);
            }
          }
        };
        vm.isSelected = function (item) {
          return vm.isActive(item);
        };
      }
    };
  }
})();

